import { TAssetsSvgMapValue } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { ButtonPill } from '../../widgets/Buttons/ButtonPill';
import layoutStyles from '../../widgets/layout/Layout.module.css';
import { LoadingAnimation } from '../../widgets/Animation/LoadingAnimation';
import { SvgComponent } from '../Svg/SvgComponent';
import styles from './commonScreen.module.css';

type TAddProps = {
    hasBorder?: boolean;
    breakWord?: boolean;
};

type TCommonScreenProps = (
    | {
          useIcon: true;
          useSpinner?: false;
          Icon:
              | React.ComponentType<{
                    fill?: string;
                }>
              | React.FC;
      }
    | {
          useIcon: false;
          useSpinner?: false;
          iconName: TAssetsSvgMapValue;
      }
    | {
          useSpinner: true;
          useIcon?: false;
      }
) & {
    useBackground?: boolean;
    headerText?: string;
    secondaryText?: string;
    buttonLabel?: string;
    buttonHandleClick?: () => void;
    mainText?: string;
    uid?: string;
    fill?: string;
};

export const CommonScreen = (props: TCommonScreenProps & TAddProps) => {
    const {
        useIcon,
        headerText,
        secondaryText,
        mainText,
        hasBorder,
        breakWord,
        buttonLabel,
        buttonHandleClick,
        useBackground = true,
        fill = 'pink_100',
    } = props;
    return (
        <div className={clsx(styles.wrapper, useBackground && styles.background)} data-test={props.uid}>
            <div className={styles.container}>
                <div className={styles.centerContainer}>
                    <div>
                        {useIcon && props.Icon && <props.Icon fill={fill} />}
                        {!useIcon && !props.useSpinner && props.iconName && <SvgComponent name={props.iconName} fill={fill} width={80} height={80} />}
                        {props.useSpinner && (
                            <div style={{ position: 'relative', zIndex: 1000 }}>
                                <LoadingAnimation isWidget={false} />
                            </div>
                        )}
                    </div>
                    {/* Для фиолетового выделения следующая конструкция: <><span>{purpleText}</span>{headerText}</span></>*/}
                    {headerText && <div className={styles.headerText}>{headerText}</div>}
                    {secondaryText && <div className={styles.secondaryText}>{secondaryText}</div>}
                    {/* текст небольшого размера */}
                    {mainText && <span className={clsx(styles.mainText, hasBorder && styles.hasBorder, breakWord && styles.breakWord)}>{mainText}</span>}
                    {buttonLabel && (
                        <div className={clsx(layoutStyles.floatingLayout, layoutStyles.bottom)}>
                            <div className={clsx(layoutStyles.horizontalLayout, layoutStyles['arrangement-end'], styles.buttonCenterContainer)}>
                                <ButtonPill
                                    isWidget={false}
                                    label={buttonLabel}
                                    maxWidth={'100%'}
                                    handleClick={() => {
                                        if (buttonHandleClick) {
                                            buttonHandleClick();
                                        } else {
                                            window?.location?.reload?.();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
